/**
 * Hides navbar when scrolling down and makes it visible when
 * scrolling up.
 */

document.addEventListener("DOMContentLoaded", function () {
	el_autohide = document.querySelector(".autohide");

	if (el_autohide) {
		var last_scroll_top = 0;
		window.addEventListener("scroll", function () {

			if (window.innerWidth < 1200 && el_autohide.classList.contains("toggled")) {
				return;
			}

			let scroll_top = window.scrollY;

			if (scroll_top > 75) {
				if (scroll_top < last_scroll_top) {
					el_autohide.classList.remove("scrolled-down");
					el_autohide.classList.add("scrolled-up");
				} else {
					el_autohide.classList.remove("scrolled-up");
					el_autohide.classList.add("scrolled-down");
				}
			}
			last_scroll_top = scroll_top;
		});
		// window.addEventListener
	}
	// if

	el_navToggle = document.querySelector("#navbarSupportedContent");

	el_navToggle.addEventListener("show.bs.collapse", function () {
		document.body.classList.add("mobile-nav-visible");
	});

	el_navToggle.addEventListener("hide.bs.collapse", function () {
		document.body.classList.remove("mobile-nav-visible");
	});

});
// DOMContentLoaded  end
